module.exports = ".textbox-wrapper {\n  width: 100%;\n  position: relative; }\n  .textbox-wrapper input {\n    height: 23px;\n    width: 100%; }\n  .textbox-wrapper input.dirty {\n      border-color: #6917aa; }\n  .textbox-wrapper .validation-error {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    display: inline-block; }\n  .textbox-wrapper .input-error {\n    background-color: #e81123;\n    height: 22px;\n    padding: 5px 4px 0px 4px;\n    left: -15px;\n    margin-bottom: -3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/textbox/textbox.component.scss
// module id = ./src/app/controls/textbox/textbox.component.scss
// module chunks = main